import { formatInTimeZone } from 'date-fns-tz';

// Start dates are UTC days, like the billing anchor they line up with (00:00
// UTC), so a shopper west of UTC must not see the day before.
export default function formatStartDate(startDate) {
  return formatInTimeZone(new Date(startDate), 'UTC', 'd MMM, yyyy');
}
